module.exports = "/_next/static/images/Error@2x-4995b132adf9c49b6cfb16e99e6fc77f.webp";